import API from '../utils/request'
// 筛选条件中获取标签组 和 标签
export function getCustomerTagGroupDtoByName (data) {
  return API.get('/data/customerDataVersion/getCustomerTagGroupDtoByName', data)
}

export function deleteCustomerDataCondition (data) {
  return API.get('/data/customerDataVersion/deleteCustomerDataCondition', data)
}

export function getCustomerDataConditionDto (data) {
  return API.get('/data/customerDataVersion/getCustomerDataConditionDto', data)
}

// 通过标签筛选客户信息
export function getCustomerDataPageDto (data) {
  return API.post('/data/customerDataVersion/getCustomerDataPageDto', data)
}
// 收藏筛选
export function addCustomerDataPageCondition (data) {
  return API.post('/data/customerDataVersion/addCustomerDataPageCondition', data)
}
// 查看标签
export function getCustomerTagGroupDtoList (data) {
  return API.get('/data/customerDataVersion/getCustomerDataCustomerTagGropDtoList', data)
}
